module.exports = __webpack_public_path__ + "static/media/img3.96a96aba.png";